/**
 * **Die drei Arten eines Dokuments der Ablage**
 * ([Z-14](../../../docs/phasen/zusatz-14-ablage.md)).
 *
 * Steht hier und nicht nur im Schema, weil die Oberfläche die Liste für das Anlegen-Formular
 * braucht – und `@netcon-work/db` im Browser nichts verloren hat.
 */
export const DOKUMENT_ARTEN = ['markdown', 'datei', 'ordner'] as const
export type DokumentArt = (typeof DOKUMENT_ARTEN)[number]
